module.exports = "#toolbar {\n    padding:0;\n    width:70%;\n    margin-left:-35%;\n}\n\nheader {\n    background:#3B8598;\n    width:100%;\n}\n\n.basic-btn {\n    width:100px;\n    margin:0;\n}\n\n#page {\n    padding:3em;\n    margin:0;\n}\n\n#page img {\n    margin-top:30px;\n}\n\nh2 {\n    margin:0;\n}\n\n@media (max-width: 600px) {\n    #page {\n        padding:1em;\n    }\n    #toolbar {\n        width:90%;\n        margin-left: -45%;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/loged-in/loged-in.component.css
// module id = ./src/app/loged-in/loged-in.component.css
// module chunks = main